import { IError } from '../base/error'
import ServiceBase from '../base/service.base'

import { ICacheRequestDTO } from './cache.types'

export class Cache extends ServiceBase {
  /**
   * Store data by user
   *
   * @param data data and key to be saved
   * @returns boolean/true representing the request success
   */
  public async setCache(data: ICacheRequestDTO): Promise<boolean> {
    const url = '/cache/user'

    const response = await this.request.post<boolean, IError>(url, data)

    if (response.status === 201) {
      return true
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  /**
   * Retrive data previously stored by user
   *
   * @param key data key
   * @returns object previously stored
   */
  public async getCache<T>(key: string): Promise<T> {
    const url = `/cache/user/${key}`

    const response = await this.request.get<T, IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getManyCache<T>(keys: string[]): Promise<T[]> {
    const url = `/cache/user/many/keys?keys=${keys.join(',')}`

    const response = await this.request.get<T[], IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  /**
   * Get user keys
   *
   * @returns string array representing user stored cache keys
   */
  public async getCacheKeys(): Promise<string[]> {
    const url = `/cache/user/keys`

    const response = await this.request.get<string[], IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
